// react
import React from 'react';

// mui
import { Skeleton as MuiSkeleton, SkeletonProps as MuiSkeletonProps } from '@mui/material';

// types
interface SkeletonProps extends Omit<MuiSkeletonProps, 'sx'> {
	borderRadius?: number | string;
	width?: number | string;
	height?: number | string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
	borderRadius = 1,
	width,
	height,
	...props
}) => {
	return (
		<MuiSkeleton
			sx={{
				borderRadius,
				width,
				height,
			}}
			{...props}
		/>
	);
};
